import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  broadcastName: Yup.string().max(100).required("Enter broadcast name."),
  whenToBroadcast: Yup.string().required("Select when to broadcast."),
  broadcastDate: Yup.string().when("whenToBroadcast", {
    is: (whenToBroadcast) => whenToBroadcast === "later",
    then: Yup.string().required("Please select a date"),
  }),
  broadcastTime: Yup.string().when("whenToBroadcast", {
    is: (whenToBroadcast) => whenToBroadcast === "later",
    then: Yup.string().required("Please select valid time"),
  }),
  uploadCSVFile: Yup.string().required(
    "Please upload CSV File to create a broadcast."
  ),
  templateID: Yup.string().required("Select a template to create a broadcast."),
});

export default validationSchema;
